import { userService } from '../services';
import { mySiteActions } from './mySite';
import { roles } from '../constants';

const GETALL_REQUEST = 'userinfo/GETALL_REQUEST';
const GETALL_SUCCESS = 'userinfo/GETALL_SUCCESS';
const GETALL_FAILURE = 'userinfo/GETALL_FAILURE';

const GETBYID_REQUEST = 'userinfo/GETBYID_REQUEST';
const GETBYID_SUCCESS = 'userinfo/GETBYID_SUCCESS';
const GETBYID_FAILURE = 'userinfo/GETBYID_FAILURE';

const DELETE_REQUEST = 'userinfo/DELETE_REQUEST';
const DELETE_SUCCESS = 'userinfo/DELETE_SUCCESS';
const DELETE_FAILURE = 'userinfo/DELETE_FAILURE';

const getAll = () => {
    return dispatch => {
        dispatch(request());

        userService.getAll()
            .then(
                users => dispatch(success(users)),
                error => dispatch(failure(error.toString()))
            );
    };

    function request() { return { type: GETALL_REQUEST } }
    function success(users) { return { type: GETALL_SUCCESS, users } }
    function failure(error) { return { type: GETALL_FAILURE, error } }
};

const getUserinfoById = (id) => {
    return dispatch => {
        dispatch(request());

        userService.getUserinfoById(id)
            .then(
                user => {
                    dispatch(success(user));
                    if (user.myRole === roles.userRole) dispatch(mySiteActions.getMySiteList(user.userID));
                },
                error => dispatch(failure(error.toString()))
            );
    };

    function request() { return { type: GETBYID_REQUEST } }
    function success(user) { return { type: GETBYID_SUCCESS, user } }
    function failure(error) { return { type: GETBYID_FAILURE, error } }
};

const getUserinfo = () => {
    return dispatch => {
        dispatch(request());
        userService.getMyInfo()
        .then(
            user => {
                dispatch(success(user));
                if (user.myRole === roles.userRole) dispatch(mySiteActions.getMySiteList(user.userID));
            },
            error => dispatch(failure(error.toString()))
        );
    };

    function request() { return { type: GETBYID_REQUEST } }
    function success(user) { return { type: GETBYID_SUCCESS, user } }
    function failure(error) { return { type: GETBYID_FAILURE, error } }
};

// prefixed function name with underscore because delete is a reserved word in javascript
const _delete = (id) => {
    return dispatch => {
        dispatch(request(id));

        userService.delete(id)
            .then(
                user => dispatch(success(id)),
                error => dispatch(failure(id, error.toString()))
            );
    };

    function request(id) { return { type: DELETE_REQUEST, id } }
    function success(id) { return { type: DELETE_SUCCESS, id } }
    function failure(id, error) { return { type: DELETE_FAILURE, id, error } }
}

export const userinfoActions = {
    getAll,
    getUserinfoById,
    getUserinfo,
    delete: _delete
};


function userinfo(state = {}, action) {
    switch (action.type) {
        case GETALL_REQUEST:
            return {
                loading: true
            };
        case GETALL_SUCCESS:
            return {
                items: action.users
            };
        case GETALL_FAILURE:
            return { 
                error: action.error
            };
        case GETBYID_REQUEST:
            return {
                loading: true
            };
        case GETBYID_SUCCESS:
            return {
                item: action.user
            };
        case GETBYID_FAILURE:
            return { 
                error: action.error
            };
        case DELETE_REQUEST:
            // add 'deleting:true' property to user being deleted
            return {
                ...state,
                items: state.items.map(user =>
                    user.id === action.id
                    ? { ...user, deleting: true }
                    : user
                )
            };
        case DELETE_SUCCESS:
            // remove deleted user from state
            return {
                items: state.items.filter(user => user.id !== action.id)
            };
        case DELETE_FAILURE:
            // remove 'deleting:true' property and add 'deleteError:[error]' property to user 
            return {
                ...state,
                items: state.items.map(user => {
                    if (user.id === action.id) {
                        // make copy of user without 'deleting:true' property
                        const { deleting, ...userCopy } = user;
                        // return copy of user with 'deleteError:[error]' property
                        return { ...userCopy, deleteError: action.error };
                    }
        
                    return user;
                })
            };
        default:
            return state
    }
}

export default userinfo;